import { InjectConfig, PaConfigKey } from '@ddt-web/config-layer';
import * as isEmpty from 'lodash/isEmpty';

import { PeerComparisonGroup } from './peer-comparison-group';
export class PeerComparisonGroupBuilder {
	@InjectConfig(PaConfigKey.PEER_COMPARISON_CONFIG) private readonly paPeerComparisonConfig = {};

	private groupName: string;
	private minRange: number;
	private maxRange: number;

	public build(): PeerComparisonGroup {
		const peerComparisonGroup = new PeerComparisonGroup();

		peerComparisonGroup.groupName = this.groupName;
		peerComparisonGroup.minRange = this.minRange;
		peerComparisonGroup.maxRange = this.maxRange;

		return peerComparisonGroup;
	}

	public setByGroupName(groupName: string): PeerComparisonGroupBuilder {
		const peerGroup: PeerComparisonGroup = !isEmpty(this.paPeerComparisonConfig) ? this.paPeerComparisonConfig?.[groupName] : {} as any;
		this.setPeerComparisonGroupObject(groupName, peerGroup.minRange, peerGroup.maxRange);
		return this;
	}

	/**
	 * Helpers
	 */
	private setPeerComparisonGroupObject(groupName: string, minRange: number, maxRange: number): void {
		this.groupName = groupName;
		this.minRange = minRange;
		this.maxRange = maxRange;
	}
}
